var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.290296 7.38774C-0.0986649 7.77982 -0.0961361 8.41298 0.295944 8.80194L6.68527 15.1404C7.07735 15.5294 7.71051 15.5269 8.09947 15.1348C8.48844 14.7427 8.48591 14.1095 8.09383 13.7206L2.41442 8.08637L8.04864 2.40697C8.4376 2.01489 8.43507 1.38173 8.04299 0.992766C7.65091 0.603805 7.01775 0.606333 6.62879 0.998414L0.290296 7.38774ZM24.036 7.00001L0.996228 7.09203L1.00422 9.09201L24.044 8.99999L24.036 7.00001Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.72e467d70ad3121a06d7dc946b184e52.svg";
export { ForwardRef as ReactComponent };